import * as Yup from "yup";

export const RoleFormValidation = Yup.object({
  name: Yup.string()
    .required("Name is required")
    .min(1)
    .max(100),
});
